// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BF1moqusCokuiOja8dhr {
    display: flex;
    justify-content: center;
    flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/features/auth/components/SocketBreakingError/SocketBreakingError.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,OAAO;AACX","sourcesContent":[".main {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `BF1moqusCokuiOja8dhr`
};
module.exports = ___CSS_LOADER_EXPORT___;
